import { Store } from '@betgames/bg-state-manager';
import { StoresEntity } from '@bg-shared/business/StoreFeature/StoresEntity';
import { GameId } from '@bg-shared/enums/GameId';
import { IStagedBet } from '@bg-shared/business/CasinoBetting/interfaces';

export const casinoStagedBetsEntity = new StoresEntity(
    class CasinoStagedBets extends Store<IStagedBet[]> {
        constructor(gameId: GameId) {
            super({
                key: `CasinoStagedBets/${gameId}`,
                default: [],
            });
        }
    },
);
